module.exports = __webpack_public_path__ + "img/lecture_icon.61063b9f.svg";